var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.667,
    height: 24,
    viewBox: "0 0 18.667 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.389 0.222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.408,2.278H41.5V.5h1.908a.222.222,0,0,1,.157.38l-.352.352a.222.222,0,0,0,0,.314l.352.352A.222.222,0,0,1,43.408,2.278Z",
    transform: "translate(-41.5 -0.5)",
    fill: "#6fa4d8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.722,3.333a.222.222,0,0,1-.222-.222V.222a.222.222,0,1,1,.444,0V3.111A.222.222,0,0,1,40.722,3.333Z",
    transform: "translate(-40.5 0)",
    fill: "#55525b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.611 13.556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.222,30.5H33.889a.889.889,0,0,0-.889.889v.889h7.111v-.889A.889.889,0,0,0,39.222,30.5Z",
    transform: "translate(-33 -30.5)",
    fill: "#353744"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.833 15.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.889,34.5H30.778C29.8,34.5,29,35.026,29,35.675v7.492H39.667V35.675C39.667,35.026,38.871,34.5,37.889,34.5Z",
    transform: "translate(-29 -34.5)",
    fill: "#5c76b2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.833 15.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.556,34.5H30.778c-.982,0-1.778.432-1.778.964v6.147h5.333V35.464C34.333,34.932,33.537,34.5,32.556,34.5Z",
    transform: "translate(-29 -34.5)",
    fill: "#6fa4d8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.369 17.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.568,41.513l-1.241-1.241a.222.222,0,0,0-.314,0l-1.241,1.241a.223.223,0,0,0,.157.38h.352v2.222a.445.445,0,0,0,.444.444h.889a.445.445,0,0,0,.444-.444V41.893h.352A.222.222,0,0,0,46.568,41.513Z",
    transform: "translate(-43.706 -40.207)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.611 13.556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.667,30.5H33.889a.889.889,0,0,0-.889.889v.889h3.556v-.889A.889.889,0,0,0,35.667,30.5Z",
    transform: "translate(-33 -30.5)",
    fill: "#55525b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.333,11.167V8.5H30.222v.889h-.889A1.335,1.335,0,0,0,28,10.722v.444a2.225,2.225,0,0,0,2.222,2.222h.786a3.551,3.551,0,0,0,2.325,1.3v1.364A1.333,1.333,0,0,1,32,17.389a.889.889,0,0,0-.889.889h5.333a.889.889,0,0,0-.889-.889,1.333,1.333,0,0,1-1.333-1.333V14.692A3.554,3.554,0,0,0,37.333,11.167ZM30.222,12.5a1.335,1.335,0,0,1-1.333-1.333v-.444a.445.445,0,0,1,.444-.444h.889v.889a3.538,3.538,0,0,0,.261,1.333Z",
    transform: "translate(-13.611 -4.722)",
    fill: "#fbbe18"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.722 2.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.444,7.389h-8a.444.444,0,0,1,0-.889h8a.444.444,0,1,1,0,.889Z",
    transform: "translate(-31 -6.5)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.167 2.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,6.5H41a.444.444,0,0,1,0,.889h4A.444.444,0,0,0,45,6.5Z",
    transform: "translate(-41 -6.5)",
    fill: "#f68820"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41,9.389h-.889V8.5H33v.889h3.556v1.778a3.551,3.551,0,0,1-1.778,3.076,3.548,3.548,0,0,0,1.333.449v.919h.444v2.667h2.667a.889.889,0,0,0-.889-.889A1.333,1.333,0,0,1,37,16.056V14.692a3.551,3.551,0,0,0,2.325-1.3h.786a2.225,2.225,0,0,0,2.222-2.222v-.444A1.335,1.335,0,0,0,41,9.389Zm.444,1.778A1.335,1.335,0,0,1,40.111,12.5H39.85a3.538,3.538,0,0,0,.261-1.333v-.889H41a.445.445,0,0,1,.444.444Z",
    transform: "translate(-16.389 -4.722)",
    fill: "#f68820"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.611 5.556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.778,
    cy: 0.778,
    r: 0.778,
    fill: "#fbd301"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.167 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.444,14.389h.889a.444.444,0,1,0,0-.889h-.889a.444.444,0,1,0,0,.889Z",
    transform: "translate(-23 -13.5)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.379 10.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.738,25.494l.628-.628a.444.444,0,0,0-.628-.628l-.628.628a.444.444,0,0,0,.628.628Z",
    transform: "translate(-27.979 -24.107)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.436 10.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.994,24.866l-.628-.628a.444.444,0,1,0-.628.628l.628.628a.444.444,0,0,0,.628-.628Z",
    transform: "translate(-50.607 -24.107)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.389 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.333,13.5h-.889a.444.444,0,1,0,0,.889h.889a.444.444,0,0,0,0-.889Z",
    transform: "translate(-55 -13.5)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.436 0.658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.366,1.609l-.628.628a.444.444,0,1,0,.628.628l.628-.628a.444.444,0,0,0-.628-.628Z",
    transform: "translate(-50.607 -1.479)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.38 0.657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.11,2.238l.628.628a.444.444,0,1,0,.628-.628l-.628-.628a.444.444,0,1,0-.628.628Z",
    transform: "translate(-27.979 -1.479)",
    fill: "#fbbe18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 18.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.889,44H18.778C17.8,44,17,44.526,17,45.175v4.7H27.667v-4.7C27.667,44.526,26.871,44,25.889,44Z",
    transform: "translate(-17 -44)",
    fill: "#353744"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 19.556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.556,44H18.778C17.8,44,17,44.371,17,44.83v3.319h5.333V44.83C22.333,44.371,21.537,44,20.556,44Z",
    transform: "translate(-17 -44)",
    fill: "#55525b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6);
export default __webpack_public_path__ + "static/media/Step6.a79184fc1b0ab5216fe2e4ad53a745c9.svg";
export { ForwardRef as ReactComponent };